import { createForm } from '../../../factories'

export default createForm(['email', 'password', 'redirectUrl'])



// WEBPACK FOOTER //
// ./src/store/modules/token/forms/login.js